import { Modal } from "antd-mobile";

const utils = {
  stringToNumber(string) {
    return string.charCodeAt(0) //Number(escape().replace(/[^\d]+/g, ''))
  },
  guid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join('');
  },
  toFloat(value, decimals) {
    decimals = decimals || 2
    if (!value) {
      return 0.00
    }
    let arr = String(value).split('.')
    let float = ''

    if (arr[1]) {
      float = arr[1].substr(0, 2)
    }
    if (float.length < decimals) {
      for (let i = 0, len = decimals - float.length; i < len; i++) {
        float += '0'
      }
    }
    return `${arr[0]}.${float}`
  },
  cooldown(ts) {
    let pre = ts < 0 ? '-' : ''
    ts = Math.abs(ts)
    let dd = parseInt(ts / 1000 / 60 / 60 / 24, 10)
    let hh = parseInt(ts / 1000 / 60 / 60 % 24, 10);
    hh += dd * 24
    hh = hh < 10 ? '0' + hh : hh
    let mm = parseInt(ts / 1000 / 60 % 60, 10);
    mm = mm < 10 ? '0' + mm : mm
    let ss = parseInt(ts / 1000 % 60, 10);
    ss = ss < 10 ? '0' + ss : ss

    return `${pre}${hh}:${mm}:${ss}`
  },
  baseToBlob: (base64File, params) => {
    let arr = base64File.split(','), mime = arr[0].match(/:(.*?);/)[1], // 转成blob
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    /*
        if(mime=='image/png')
            params.format = 'png';
        else if(mime=='image/bmp')
            params.format = 'bmp';
        else if(mime=='image/gif')
            params.format = 'git';
        else if(mime=='image/jpeg')
            params.format = 'jpg';

        return new window.File([new Blob([u8arr], { type: mime })], `${new Date().getTime()}.${params.format}`, { type: mime }) // 转成file
    */
    return new Blob([u8arr], { type: mime });

  },
  isWeixin() { //判断是否是微信
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
  },
  isAndroid() {
    const ua = navigator.userAgent
    return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
  },
  isIos() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && navigator.platform.indexOf("Mac") != 0
  },
  isMobile() {
    return this.isAndroid() || this.isIos() || /Mobile/i.test(navigator.userAgent)
  },
  formatIdCard: (idcard) => {
    return idcard ? idcard.substr(0, idcard.length - 5) + '*****' : ''
  },
  formatTimeleft: (timeleft) => {
    if (timeleft < 0) {
      return `00:00:00`
    }
    let hour = Math.floor(timeleft / 60 / 60)
    let minute = Math.floor(timeleft / 60) % 60
    let second = timeleft % 60
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minute < 10) {
      minute = '0' + minute
    }
    if (second < 10) {
      second = '0' + second
    }
    return `${hour}:${minute}:${second}`
  },
  alert(message, options = {}) {
    const { title = '提示', buttonText = '确定' } = options
    Modal.alert(title, message, [
      {
        text: buttonText, onPress: () => {
          options.callback && options.callback()
        },
      },
    ])
  },
  timestampToDate(timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    return Y + M + D;
  },
  timestampToTime(timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return Y + M + D + h + m;
  },
  //钉钉
  isDDReady: false,

  toDate(str) {
    let times = new Date(str);
    let Y = times.getFullYear()
    let M = times.getMonth() + 1 < 10 ? '0' + (times.getMonth() + 1) : times.getMonth() + 1
    let D = times.getDate() < 10 ? '0' + (times.getDate()) : times.getDate()
    let h = times.getHours() < 10 ? '0' + (times.getHours()) : times.getHours()
    let m = times.getMinutes() < 10 ? '0' + (times.getMinutes()) : times.getMinutes()
    let s = times.getSeconds() < 10 ? '0' + (times.getSeconds()) : times.getSeconds()
    return times = Y + "-" + M + "-" + D + ' ' + h + ":" + m;
  },
  getYMDDate(str) {
    let times = new Date(str);
    let Y = times.getFullYear();
    let M = times.getMonth() + 1 < 10 ? '0' + (times.getMonth() + 1) : times.getMonth() + 1;
    let D = times.getDate() < 10 ? '0' + (times.getDate()) : times.getDate();
    return Y + "-" + M + "-" + D
  },
  getHMSDate(str) {
    let times = new Date(str);
    let h = times.getHours() < 10 ? '0' + (times.getHours()) : times.getHours();
    let m = times.getMinutes() < 10 ? '0' + (times.getMinutes()) : times.getMinutes();
    let s = times.getSeconds() < 10 ? '0' + (times.getSeconds()) : times.getSeconds();
    return h + ":" + m;
  },
  // 判断是否为全屏
  isFullScreen() {
    var explorer = window.navigator.userAgent.toLowerCase();
    if (explorer.indexOf('chrome') > 0) {//webkit
      if (document.body.scrollHeight === window.screen.height && document.body.scrollWidth === window.screen.width) {
        return true;
      } else {
        return false;
      }
    } else {//IE 9+  fireFox
      if (window.outerHeight === window.screen.height && window.outerWidth === window.screen.width) {
        return true;
      } else {
        return false;
      }
    }
  },
  // // 全屏
  enterFullScreen() {
    let el = document.documentElement;
    let rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
    if (rfs) {
      rfs.call(el);
    } else if (window?.XMLHttpRequest) {
      if (typeof window.XMLHttpRequest !== 'undefined') {
        // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
        var wscript = new XMLHttpRequest('WScript.Shell');
        if (wscript != null) {
          wscript.SendKeys('{F11}');
        }
      }
    }
  },
  // 退出全屏
  exitFullScreen() {
    let el = document
    let cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
    if (cfs) {
      cfs.call(el)
    } else if (typeof window.XMLHttpRequest !== 'undefined') {
      // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
      var wscript = new XMLHttpRequest('WScript.Shell');
      if (wscript != null) {
        wscript.SendKeys('{F11}');
      }
    }
  }
}

export default utils